import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { getUserLogged, isConsultantOrHolding, isSalesman, isHolding } from "@/js/http/auth.js";
import * as orderHandler from "@/js/order/order.js";
import { getCurrencyUser, setCurrencyUsedForCartAndExplore, getIdCurrencyUsedForCartAndExplore } from "@/js/currency/currencies.js";
import { getFullNameUser } from "@/js/user/user.js";
import { filterVAutocomplete, getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { listUserGroups } from "@/js/lists.ts";
import ConfirmationDialog from "@/components/modal/ConfirmationDialog.vue";
import SendInvitationAsConsultantModal from "@/components/user/SendInvitationAsConsultantModal.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "ThirdPartyUserSelector",
  components: {
    ConfirmationDialog: ConfirmationDialog,
    SendInvitationAsConsultantModal: SendInvitationAsConsultantModal,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      thirdPartyUserSelected: null,
      lastThirdPartyUserSelected: null,
      thirdPartyUserList: [],
      isLoading: true,
      boolRenderer: false,
      isExtendedList: false,
      managedExceptions: {
        error: {
          EMPTY_BASKETY_WRONG_STATUS: "There is a data incoherence. You should refresh the page. Else close open tabs, sign out et sign in again."
        }
      },
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    inputPlaceholder: function inputPlaceholder() {
      var _this$thirdPartyUserS;
      var isLoading = this.isLoading;
      var isUserSelected = !!((_this$thirdPartyUserS = this.thirdPartyUserSelected) !== null && _this$thirdPartyUserS !== void 0 && _this$thirdPartyUserS.id_user);
      if (!isHolding(this.loggedUserData)) {
        if (isLoading) {
          return isUserSelected ? "Loading selected customer" : "Loading list of customers";
        } else {
          return "Search for a customer";
        }
      } else {
        if (isLoading) {
          return isUserSelected ? "Loading selected" : "Loading list";
        } else {
          return "Search";
        }
      }
    },
    canRestrictList: function canRestrictList() {
      return isSalesman(this.loggedUserData) && this.isExtendedList && (!this.thirdPartyUserSelected || this.thirdPartyUserSelected.salesman_id === +this.loggedUserData.idUser);
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$thirdPartyUser;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.fetchList();
          case 2:
            _this2.thirdPartyUserSelected = orderHandler.getThirdPartyUserSelected();
            _this2.lastThirdPartyUserSelected = orderHandler.getThirdPartyUserSelected();
            if (!(isSalesman(_this2.loggedUserData) && +((_this2$thirdPartyUser = _this2.thirdPartyUserSelected) === null || _this2$thirdPartyUser === void 0 ? void 0 : _this2$thirdPartyUser.id_user) > 0)) {
              _context.next = 8;
              break;
            }
            if (_this2.thirdPartyUserList.some(function (x) {
              return x.id_user == _this2.thirdPartyUserSelected.id_user;
            })) {
              _context.next = 8;
              break;
            }
            _context.next = 8;
            return _this2.fetchList(true);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    openSendInvitationAsConsultantModal: function openSendInvitationAsConsultantModal() {
      this.$refs.SendInvitationAsConsultantModal.open();
    },
    selectThirdPartyUserConfirm: function selectThirdPartyUserConfirm() {
      var _this$lastThirdPartyU,
        _this3 = this;
      if (((_this$lastThirdPartyU = this.lastThirdPartyUserSelected) === null || _this$lastThirdPartyU === void 0 ? void 0 : _this$lastThirdPartyU.id_user) != 0 && orderHandler.getCurrentOrder()) {
        this.$refs.confirmationDialog.open("CHANGE USER", "Are you sure you want to change the user? All items in the cart will be removed!").then(function (confirm) {
          if (confirm) {
            _this3.selectThirdPartyUser();
          } else {
            _this3.boolRenderer = !_this3.boolRenderer;
            _this3.thirdPartyUserSelected.id_user = _this3.lastThirdPartyUserSelected.id_user;
          }
        });
      } else {
        this.selectThirdPartyUser();
      }
    },
    selectThirdPartyUser: function selectThirdPartyUser() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, currentOrder, _data, newCurrency, response, _yield$orderHandler$f, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this4;
              currentOrder = orderHandler.getCurrentOrder();
              if (!currentOrder) {
                _context2.next = 8;
                break;
              }
              _data = {
                orderId: +currentOrder.id_order,
                userId: +_this4.loggedUserData.idUser
              };
              _context2.next = 6;
              return request("/v1/basket/".concat(currentOrder.id_order), "delete", _data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 6:
              orderHandler.removeOrderFromStorage();
              _this4.$EventBus.$emit("BasketRemoved");
            case 8:
              _this4.lastThirdPartyUserSelected = _this4.thirdPartyUserSelected;
              newCurrency = null;
              if (!_this4.thirdPartyUserSelected) {
                _context2.next = 14;
                break;
              }
              newCurrency = _this4.thirdPartyUserSelected.default_currency;
              _context2.next = 18;
              break;
            case 14:
              _context2.next = 16;
              return getCurrencyUser();
            case 16:
              response = _context2.sent;
              newCurrency = response.data.currency;
            case 18:
              if (getIdCurrencyUsedForCartAndExplore() !== newCurrency) {
                setCurrencyUsedForCartAndExplore(newCurrency);
                _this4.$EventBus.$emit("CurrencyUpdated", newCurrency);
              }
              orderHandler.setThirdPartyUserSelected(_this4.thirdPartyUserSelected);
              _context2.next = 22;
              return orderHandler.fetchBasket();
            case 22:
              _yield$orderHandler$f = _context2.sent;
              data = _yield$orderHandler$f.data;
              if (!!data) {
                orderHandler.setCurrentOrder(data);
                _this4.$EventBus.$emit("update-cart");
              }
              orderHandler.refreshCategoryUser(_this4);
              _this4.$emit("changeUser");
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //Sync with ExportPriceList !
    fetchList: function fetchList() {
      var _arguments = arguments,
        _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var forceEntireList, _this, response, values, _userLogged$delivery_, _userLogged$company_n, userLogged, thirdSelected;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              forceEntireList = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              _this5.isLoading = true;
              _this = _this5;
              _context3.next = 5;
              return request("/v1/third-party-users" + (forceEntireList ? "?forceEntireList=true" : ""), "get", {}, true, "api").catch(function (e) {
                var errorData = getErrorData(e, "Unable to get list of customers", true);
                handleErrorData(_this, errorData);
                _this.isLoading = false;
                throw e;
              });
            case 5:
              response = _context3.sent;
              values = _toConsumableArray(response.data.value);
              _this5.thirdPartyUserList = [];
              values.forEach(function (user) {
                var _user$delivery_addres, _listUserGroups$find;
                var fullName = !isHolding(_this5.loggedUserData) ? getFullNameUser(user) + " - " + user.delivery_address.country.iso_code + ((_user$delivery_addres = user.delivery_address.state) !== null && _user$delivery_addres !== void 0 && _user$delivery_addres.iso_state ? "-".concat(user.delivery_address.state.iso_state) : "") + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
                  return x.id === user.user_group.toUpperCase();
                })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.login + ")" : getFullNameUser(user);
                _this5.thirdPartyUserList.push(_objectSpread(_objectSpread({}, user), {}, {
                  full_name: fullName
                }));
              });
              _this5.thirdPartyUserList.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              if (!(isConsultantOrHolding(_this5.loggedUserData) && !_this5.thirdPartyUserList.some(function (x) {
                return x.id_user == _this5.loggedUserData.idUser;
              }))) {
                _context3.next = 18;
                break;
              }
              _context3.next = 13;
              return getUserLogged();
            case 13:
              userLogged = _context3.sent;
              userLogged.full_name = isHolding(_this5.loggedUserData) ? "All group" : "Me : " + getFullNameUser(userLogged) + " - " + userLogged.delivery_address.country.iso_code + ((_userLogged$delivery_ = userLogged.delivery_address.state) !== null && _userLogged$delivery_ !== void 0 && _userLogged$delivery_.iso_state ? "-".concat(userLogged.delivery_address.state.iso_state) : "") + " " + (((_userLogged$company_n = userLogged.company_name) === null || _userLogged$company_n === void 0 ? void 0 : _userLogged$company_n.length) > 0 ? "Professional" : "Individual") + " (" + userLogged.login + ")";
              _this5.thirdPartyUserList.unshift(userLogged);
              thirdSelected = orderHandler.getThirdPartyUserSelected();
              if (thirdSelected === null) {
                _this5.thirdPartyUserSelected = userLogged;
                _this5.selectThirdPartyUserConfirm();
              }
            case 18:
              _this5.isExtendedList = forceEntireList;
              _this5.isLoading = false;
            case 20:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onUserInput: function onUserInput(value) {
      if (isHolding(this.loggedUserData) && value === null) {
        this.thirdPartyUserSelected = this.lastThirdPartyUserSelected;
        this.boolRenderer = !this.boolRenderer;
      }
    },
    filterVAutocomplete: filterVAutocomplete,
    isConsultantOrHolding: isConsultantOrHolding,
    isSalesman: isSalesman
  }
};